import { contentTypes } from 'ggApp/modules/contentful/models/contentTypes';
import { cfReferenceList } from '../utils/mappers/cfReferenceList';
import { CfUspCard } from '../models/uspCard';
import { CfFaqWidget } from '../models/faqWidget';
import { CfTextBlock } from '../models/textBlock';

export default class CfPartnerProductPage {
    static contentType = contentTypes.CfPartnerProductPage;

    static pageName = 'PARTNER_LANDING_PAGE';

    static defaultStoreCode = 'default';

    constructor(entity) {
        const { fields } = entity;
        const { storeCode, faqBlockTitle, faqsList, groverDescription } = fields || {};

        Object.assign(this, {
            storeCode,
            faqBlockTitle,
            isDefaultStore: storeCode === CfPartnerProductPage.defaultStoreCode,
            faqsList: faqsList && cfReferenceList(faqsList).map((item) => new CfFaqWidget(item)),
            groverDescription: groverDescription && new CfTextBlock(groverDescription),
        });

        if (fields.whyRentBlock) {
            this.whyRentBlock = {
                cards: cfReferenceList(fields.whyRentBlock).map(
                    (item) => new CfUspCard(CfUspCard.mapCfEntity(item)),
                ),
            };
        }

        if (fields.howItWorksBlock) {
            this.howItWorksBlock = {
                cards: cfReferenceList(fields.howItWorksBlock).map(
                    (item) => new CfUspCard(CfUspCard.mapCfEntity(item)),
                ),
                title: fields.howItWorksBlockTitle,
            };
        }
    }
}
